import React from 'react'
import { Container, Typography, Counter } from '@cleartrip/ct-design-components'
import { totalTravellersCount } from '@/constants/components/common'
import { labelPluralize } from '@/utils/general/browserHelper'
import TooltipMessage from '@/components/home/TravellersAndClass/Traveller/TooltipMessage'

const TravellersCounter = ({ travellerData = {}, travellers = {}, setTravellers = (arg1 = {}) => {}, query, activeFare = '' }) => {
    const { type: travellerType, label = '', minValue, description } = travellerData

    const currentFare = activeFare !== undefined ? activeFare : (query?.sft || '')
    const shouldDisable = currentFare === 'student' || currentFare === 'senior_citizen'

    let max = totalTravellersCount
    let travellerLabel = ''

    if (travellerType === 'adults') {
        max = totalTravellersCount - travellers.childs
        travellerLabel = labelPluralize(travellers.adults, label, 's')
    } else if (travellerType === 'childs') {
        max = shouldDisable ? 0 : totalTravellersCount - travellers.adults
        travellerLabel = label
    } else {
        max = shouldDisable ? 0 : travellers.adults
        travellerLabel = labelPluralize(travellers.adults, label, 's')
    }

    const updateCounter = (value, operation) => {
        if (operation === 'INCREMENT') {
            setTravellers({
                ...travellers,
                [travellerType]: travellers[travellerType] + 1
            })
        } else {
            if (travellerType === 'adults') {
                setTravellers({
                    ...travellers,
                    adults: travellers.adults - 1,
                    infants: travellers.infants >= travellers.adults ? travellers.infants - 1 : 0
                })
            } else {
                setTravellers({
                    ...travellers,
                    [travellerType]: travellers[travellerType] - 1
                })
            }
        }
    }

    return (
        <TooltipMessage
            shouldDisable={shouldDisable && travellerType !== 'adults'}
            title={travellerType}
            sft={currentFare}
            containerWidth="400px"
            tooltipWidth="216px"
        >
            <Container className="flex flex-between flex-middle px-6 py-3">
                <Container>
                    <Typography variant="B1" className="fs-3 c-inherit" isDisabled={shouldDisable && travellerType !== 'adults'}>
                        {travellerLabel}
                    </Typography>
                    <Typography variant="B3" color="subheading">
                        {description}
                    </Typography>
                </Container>
                <Counter
                    styleConfig={{
                        root: {
                            className: 'Primary-500'
                        },
                        minusIcon: {
                            stroke: '#3366CC'
                        },
                        plusIcon: {
                            stroke: '#3366CC'
                        }
                    }}
                    max={max}
                    value={travellers[travellerType]}
                    min={minValue}
                    onChange={updateCounter}
                    isDisabled={shouldDisable && travellerType !== 'adults'}
                    minimumIntegerDigitsValue={1}
                />
            </Container>
        </TooltipMessage>
    )
}

export default TravellersCounter
